import { render } from "./Calculator2.vue?vue&type=template&id=46b80c38"
import script from "./Calculator2.vue?vue&type=script&lang=js"
export * from "./Calculator2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__